import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { QRCodeCanvas } from 'qrcode.react';
import { createUserSeller } from '../../Redux/Actions/actions';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import ImageSeller from '../ImageSeller/ImageSeller';
import style from './FormSellers.module.css';

const FormUsuarios = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    mail: '',
    password: '',
    name: '',
    last_name: '',
    phone_number: '',
    photo: '',
    type: 'Vendedor',
    status: true,
    martillerId: '',
    officeId: 1,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const emailInputRef = useRef(null);

  const cleanPhone = (formData.phone_number || '').replace(/[^0-9]/g, '');
  const whatsappLink = cleanPhone ? `https://wa.me/${cleanPhone}` : '';

  const handleGenerateQR = () => {
    if (!cleanPhone || cleanPhone.length < 8) {
      alert('Ingresá un número de teléfono válido (con código de país).');
      return;
    }
    setShowQR(true);
  };

  const handleDownloadQR = () => {
    const qrCanvas = document.getElementById('qrCode');
    if (!qrCanvas) return;
    const dataUrl = qrCanvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `whatsapp_qr_${cleanPhone}.png`;
    link.click();
  };

  const generatePassword = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < 8; i++) {
      password += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setFormData({ ...formData, password });
  };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  const handleEmailChange = (e) => {
    const value = e.target.value.replace('@byraices.com', '');
    setFormData({ ...formData, mail: value });
  };

  const handleEmailFocus = () => {
    const inputElement = emailInputRef.current;
    if (inputElement && inputElement.setSelectionRange) {
      const position = formData.mail.length;
      inputElement.setSelectionRange(position, position);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const capitalizedValue = (fieldValue) =>
      fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1).toLowerCase();
    setFormData({
      ...formData,
      [name]: name === 'name' || name === 'last_name' ? capitalizedValue(value) : value,
    });
  };

  const handlePhoneChange = (e) => {
    setFormData({ ...formData, phone_number: e.target.value });
    if (showQR) setShowQR(false);
  };

  const handleImageSelected = (imageFile) => {
    setFormData({ ...formData, photo: imageFile });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSubmit = new FormData();
    dataToSubmit.append('mail', `${formData.mail}@byraices.com`);
    dataToSubmit.append('password', formData.password);
    dataToSubmit.append('name', formData.name);
    dataToSubmit.append('last_name', formData.last_name);
    dataToSubmit.append('phone_number', formData.phone_number);
    dataToSubmit.append('type', formData.type);
    dataToSubmit.append('status', formData.status);
    dataToSubmit.append('martillerId', formData.martillerId);
    dataToSubmit.append('officeId', formData.officeId);
    if (formData.photo) dataToSubmit.append('photo', formData.photo);
    dispatch(createUserSeller(dataToSubmit));
  };

  return (
    <Form onSubmit={handleSubmit} className={style.formContainer}>
      <h2 className={style.formTitle}>Crear nuevo vendedor</h2>
      <p className={style.formSubtitle}>Completá los datos del nuevo usuario del equipo.</p>

      <FormGroup>
        <Label for="mail">Correo Electrónico</Label>
        <div className={style.mailContainer}>
          <Input
            type="text"
            name="mail"
            id="mail"
            className={style.inputField}
            innerRef={emailInputRef}
            value={formData.mail}
            onChange={handleEmailChange}
            onFocus={handleEmailFocus}
            required
          />
          <span className={style.emailSuffix}>@byraices.com</span>
        </div>
      </FormGroup>

      <FormGroup>
        <Label for="password">Contraseña</Label>
        <div className={style.passwordButtons}>
          <Input
            type={showPassword ? 'text' : 'password'}
            name="password"
            id="password"
            className={style.inputField}
            value={formData.password}
            onChange={handleChange}
            required
          />
          <Button type="button" className={style.secondaryButton} onClick={toggleShowPassword}>
            {showPassword ? 'Ocultar' : 'Mostrar'}
          </Button>
          <Button type="button" className={style.secondaryButton} onClick={generatePassword}>
            Generar
          </Button>
        </div>
      </FormGroup>

      <div className={style.row2}>
        <FormGroup>
          <Label for="name">Nombre</Label>
          <Input
            type="text"
            name="name"
            id="name"
            className={style.inputField}
            value={formData.name}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label for="last_name">Apellido</Label>
          <Input
            type="text"
            name="last_name"
            id="last_name"
            className={style.inputField}
            value={formData.last_name}
            onChange={handleChange}
            required
          />
        </FormGroup>
      </div>

      <FormGroup>
        <Label for="phone_number">Número de Teléfono</Label>
        <div className={style.phoneRow}>
          <Input
            type="text"
            name="phone_number"
            id="phone_number"
            className={style.inputField}
            value={formData.phone_number}
            onChange={handlePhoneChange}
            placeholder="+5492616808087"
            required
          />
          <Button
            type="button"
            className={style.qrButton}
            onClick={handleGenerateQR}
            title="Generar QR de WhatsApp con este número"
          >
            📱 Generar QR
          </Button>
        </div>
        <small className={style.hint}>
          Incluí el código de país. El QR generará un link directo a WhatsApp.
        </small>

        {showQR && cleanPhone && (
          <div className={style.qrInlinePanel}>
            <div className={style.qrInlineFrame}>
              <QRCodeCanvas id="qrCode" value={whatsappLink} size={180} includeMargin level="H" />
            </div>
            <div className={style.qrInlineInfo}>
              <span className={style.qrInlineLabel}>QR de WhatsApp</span>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className={style.qrInlineLink}
              >
                {whatsappLink}
              </a>
              <Button type="button" className={style.qrDownloadBtn} onClick={handleDownloadQR}>
                📥 Descargar QR
              </Button>
            </div>
          </div>
        )}
      </FormGroup>

      <div className={style.imageContainer}>
        <ImageSeller onImageSelected={handleImageSelected} />
      </div>

      <div className={style.row2}>
        <FormGroup>
          <Label for="type">Tipo de Usuario</Label>
          <Input
            type="select"
            name="type"
            id="type"
            className={style.inputField}
            value={formData.type}
            onChange={handleChange}
          >
            <option value="Vendedor">Vendedor</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label for="martillerId">Martillero</Label>
          <Input
            type="select"
            name="martillerId"
            id="martillerId"
            className={style.inputField}
            value={formData.martillerId}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un Martillero</option>
            <option value="2">Abi Caon</option>
            <option value="4">Julieta Garcia</option>
          </Input>
        </FormGroup>
      </div>

      <Button type="submit" className={style.primaryButton}>
        Crear Usuario
      </Button>
    </Form>
  );
};

export default FormUsuarios;
